/**
 * calendar_filters_controller.js — the calendar's filter chips, folded behind one row on a phone.
 *
 * On a phone the Show and Who chips wrap to five rows and push the week grid
 * below the fold. Collapsed, the toolbar is a single row: a toggle naming the
 * current choice ("All · Everyone") and Refresh. Tapping the toggle shows the
 * chips. From md up the chips are always shown and this controller's only
 * visible effect is nothing: the summary row is d-md-none (templates/calendar.html,
 * styles in static/css/calendar.css).
 *
 * The summary only READS the chips. static/js/calendar/core.js owns what is
 * checked: it ticks the Who chip from #calendar's data-default-assignee after the
 * calendar bundle loads, which fires no change event. Until a Who chip is checked
 * the summary names the chip matching that same attribute, so it never disagrees
 * with the painted calendar.
 */

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["summary", "toggle"];

    connect() {
        this.summarise();
    }

    toggle() {
        const expanded = this.element.classList.toggle("is-expanded");
        this.toggleTarget.setAttribute("aria-expanded", String(expanded));
    }

    summarise() {
        const type = this.element.querySelector(".event-type-radio:checked");
        this.summaryTarget.textContent = [chipLabel(type), chipLabel(this.assigneeRadio())]
            .filter(Boolean)
            .join(" · ");
    }

    assigneeRadio() {
        const radios = Array.from(this.element.querySelectorAll(".event-assignee-radio"));
        const fallback = document.getElementById("calendar")?.dataset.defaultAssignee ?? "";
        return radios.find((radio) => radio.checked)
            || radios.find((radio) => radio.value === fallback)
            || radios[0];
    }
}

function chipLabel(radio) {
    return radio?.closest(".filter-chip")?.textContent.trim() || "";
}
